import { Component } from 'react';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { ToolBar } from 'foundations-components/transitional/components/ToolBar';
import { ToolBarGroup } from 'foundations-components/transitional/components/ToolBarGroup';
import RequestStatus from '../../constants/edit/RequestStatus';
import { SCREENS } from '../../constants/TrackingConstants';
import { isPublished } from '../../utils/articleUtils';
import UsageTracker from '../../utils/UsageTracker';
import { getSelectedMultiLangCategory, getSelectedMultiLangSubcategory } from '../../utils/categorizeUtils';
import { getArticlesPath } from '../../routing/utils/internalPaths';
import ExitEditorWarningModal from '../ExitEditorWarningModal';
import ArticleLanguageVariantSwitcher from './ArticleLanguageVariantSwitcher';
import PublishButton from './PublishButton';
import SaveStatus from './SaveStatus';
import ArticleVersionsModal from './ArticleVersionsModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
class EditHeader extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      showExitWarningModal: false,
      showVersionsModal: false
    };
    this.handleExitClick = () => {
      const {
        hasLocalChanges
      } = this.props;
      if (hasLocalChanges) {
        this.setState({
          showExitWarningModal: true
        });
      } else {
        this.handleExitEditor();
      }
    };
    this.handleExitEditor = () => {
      const {
        onRouteChange,
        subscreen,
        article
      } = this.props;
      onRouteChange(getArticlesPath(article.values.hs_group_id));
      UsageTracker.track('createArticleInteraction', {
        screen: SCREENS.CREATE,
        subscreen,
        action: 'back-to-knowledge'
      });
    };
    this.handleConfirmAndExitEditor = () => {
      this.handleCloseModal();
      this.handleExitEditor();
    };
    this.handleCloseModal = () => this.setState({
      showExitWarningModal: false
    });
    this.handleOpenVersionsHistory = () => this.setState({
      showVersionsModal: true
    });
    this.handleCloseVersionsHistory = () => this.setState({
      showVersionsModal: false
    });
  }
  getRelevantSaveStatus() {
    const {
      articleSaveStatus
    } = this.props;
    const statuses = [articleSaveStatus];
    if (statuses.includes(RequestStatus.PENDING)) {
      return RequestStatus.PENDING;
    }
    if (statuses.includes(RequestStatus.FAILED)) {
      return RequestStatus.FAILED;
    }
    if (statuses.includes(RequestStatus.SUCCEEDED)) {
      return RequestStatus.SUCCEEDED;
    }
    return RequestStatus.UNINITIALIZED;
  }
  renderMiddleToolbarGroup() {
    const {
      article,
      subscreen,
      knowledgeScopes,
      onAddToGroup,
      onRemoveFromGroup
    } = this.props;
    const hasLanguage = !!article.values.hs_language;
    if (hasLanguage) {
      return /*#__PURE__*/_jsx(ToolBarGroup, {
        children: /*#__PURE__*/_jsx(ArticleLanguageVariantSwitcher, {
          article: article,
          subscreen: subscreen,
          knowledgeScopes: knowledgeScopes,
          onAddToGroup: onAddToGroup,
          onRemoveFromGroup: onRemoveFromGroup
        })
      });
    }
    return /*#__PURE__*/_jsx(ToolBarGroup, {});
  }
  render() {
    const {
      article,
      customSlugEnding,
      disablePublish,
      hasBufferedChanges,
      isDomainNotConnectedError,
      isPublishArticleTemporarilyDisabled,
      linksColor,
      multiLangCategories,
      noSelectedListError,
      noSelectedAccessGroupError,
      knowledgeScopes,
      onErrorFocus,
      onPublishArticle,
      selectedCategoryId,
      templateSettings
    } = this.props;
    const {
      showExitWarningModal,
      showVersionsModal
    } = this.state;
    const saveStatus = this.getRelevantSaveStatus();
    const selectedMultiLangCategory = getSelectedMultiLangCategory(selectedCategoryId, multiLangCategories.get('categories'));
    const selectedMultiLangSubcategory = getSelectedMultiLangSubcategory(selectedCategoryId, selectedMultiLangCategory);
    const categoryTranslation = selectedMultiLangCategory && selectedMultiLangCategory.get('nameTranslations').find(item => item.language === article.values.hs_language);
    const subcategoryTranslation = selectedMultiLangSubcategory && selectedMultiLangSubcategory.get('nameTranslations').find(item => item.language === article.values.hs_language);
    const isMissingCategoryTranslation = Boolean(selectedMultiLangCategory && !categoryTranslation);
    const isMissingSubcategoryTranslation = Boolean(selectedMultiLangSubcategory && !subcategoryTranslation);
    const articleCategoryTranslationLanguages = selectedMultiLangCategory && selectedMultiLangCategory.get('nameTranslations').map(translation => translation.language).toJS();
    const articleSubcategoryTranslationLanguages = selectedMultiLangSubcategory && selectedMultiLangSubcategory.get('nameTranslations').map(translation => translation.language).toJS();
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [showExitWarningModal && /*#__PURE__*/_jsx(ExitEditorWarningModal, {
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `knowledgeContentUI.edit.exitWarning.descriptionFor${isPublished(article) ? 'Update' : 'Publish'}`
        }),
        onConfirm: this.handleConfirmAndExitEditor,
        onReject: this.handleCloseModal
      }), showVersionsModal && /*#__PURE__*/_jsx(ArticleVersionsModal, {
        articleId: article.values.hs_id,
        onClose: this.handleCloseVersionsHistory,
        templateSettings: templateSettings,
        linksColor: linksColor
      }), /*#__PURE__*/_jsxs(ToolBar, {
        use: "dark",
        children: [/*#__PURE__*/_jsx(ToolBarGroup, {
          children: /*#__PURE__*/_jsx(Button, {
            "data-test-id": "exit-editor-button",
            onClick: this.handleExitClick,
            use: "secondary-ghost",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'knowledgeContentUI.button.exitButtonLabel'
            })
          })
        }), this.renderMiddleToolbarGroup(), /*#__PURE__*/_jsxs(ToolBarGroup, {
          children: [/*#__PURE__*/_jsx(SaveStatus, {
            article: article,
            status: saveStatus,
            onVersionHistoryClick: this.handleOpenVersionsHistory
          }), /*#__PURE__*/_jsx(PublishButton, {
            article: article,
            articleCategoryTranslationLanguages: articleCategoryTranslationLanguages,
            articleSubcategoryTranslationLanguages: articleSubcategoryTranslationLanguages,
            customSlugEnding: customSlugEnding,
            disablePublish: disablePublish,
            hasSelectedCategory: !!selectedMultiLangCategory,
            hasSelectedSubcategory: !!selectedMultiLangSubcategory,
            hasBufferedChanges: hasBufferedChanges,
            isDomainNotConnectedError: isDomainNotConnectedError,
            isPublishArticleTemporarilyDisabled: isPublishArticleTemporarilyDisabled,
            isMissingCategoryTranslation: isMissingCategoryTranslation,
            isMissingSubcategoryTranslation: isMissingSubcategoryTranslation,
            noSelectedListError: noSelectedListError,
            noSelectedAccessGroupError: noSelectedAccessGroupError,
            knowledgeScopes: knowledgeScopes,
            onPublishArticle: onPublishArticle,
            onErrorFocus: onErrorFocus,
            saveStatus: saveStatus,
            selectedCategoryId: selectedCategoryId
          })]
        })]
      })]
    });
  }
}
const mapStateToProps = state => ({
  knowledgeScopes: state.knowledgeScopes,
  multiLangCategories: state.multiLangCategories
});
export default connect(mapStateToProps, null)(EditHeader);